import 'slick-carousel';

const SELECTOR = '[data-home-partners-carousel]';

const options = {
  infinite: true,
  dots: false,
  slidesToShow: 5,
  slidesToScroll: 5,
  autoplay: true,
  autoplaySpeed: 5000,
  mobileFirst: false /* Note: Not using mobile first approach in config, to DRY it up! */,
  responsive: [
    {
      breakpoint: 1100,
      settings: { slidesToShow: 4, slidesToScroll: 4 }
    },
    {
      breakpoint: 900,
      settings: { slidesToShow: 3, slidesToScroll: 3 }
    },
    {
      breakpoint: 730,
      settings: { slidesToShow: 2, slidesToScroll: 2 }
    },
    {
      breakpoint: 420,
      settings: { slidesToShow: 1, slidesToScroll: 1 }
    }
  ]
};

class PartnersCarousel {
  constructor() {
    if ($(SELECTOR).size()) {

      $('[data-home-partners-carousel]').slick(options);
    }
  }
}

export default PartnersCarousel;



// WEBPACK FOOTER //
// ./src/javascripts/PartnersCarousel.js